import { render } from "./Directions.vue?vue&type=template&id=15d108bd"
import script from "./Directions.vue?vue&type=script&lang=js"
export * from "./Directions.vue?vue&type=script&lang=js"

import exportComponent from "D:\\p2h_proj\\californiamilkprocessorboard\\markup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__